/* eslint-disable import/prefer-default-export */
import api from '../_api';

export const studentsService = {
    patchStudent(studentUuid, payload) {
        return api.patch(`/students/student/${studentUuid}`, payload);
    },
    country(name) {
        return api.get(`/students/country/name/${name}`);
    },
    careerSalaryData(studentUuid, careerUuid) {
        return api.get(`/students/student/${studentUuid}/career/${careerUuid}/salary_data`);
    },
    careerEmployabilityData(studentUuid, careerUuid) {
        return api.get(`/students/student/${studentUuid}/career/${careerUuid}/employability_data`);
    },
    careerGradesData(studentUuid, careerUuid) {
        return api.get(`/students/student/${studentUuid}/career/${careerUuid}/grades_data`);
    },
    careerPensumData(studentUuid, careerUuid) {
        return api.get(`/students/student/${studentUuid}/career/${careerUuid}/pensum_data`);
    },
    staticStudents(queryparams) {
        return api.get('/students/static_student/', { params: queryparams });
    },
    staticStudentsToken(studentToken) {
        return api.get(`/students/static_student_token/${studentToken}`);
    },
    postStaticStudentRNE(studentData) {
        return api.post('/students/rne/', studentData);
    },
    students(queryparams) {
        return api.get('/students/student/', { params: queryparams });
    },
    postCareerPreference(studentUuid, payload) {
        return api.post(`/students/student/${studentUuid}/career_preference`, payload);
    },
    deleteCareerPreference(studentUuid, careerUuid) {
        return api.delete(`/students/student/${studentUuid}/career/${careerUuid}/delete_career_preference`);
    },
    getCareerPreferences(studentUuid) {
        return api.get(`/students/student/${studentUuid}/career_preference`);
    },
    postQuestionResponse(studentUuid, payload) {
        return api.post(`/students/student/${studentUuid}/student_response`, payload);
    },
    postInitialQuestions(studentUuid, payload) {
        return api.patch(`/students/initial_questions/${studentUuid}`, payload);
    },
    postMessage(message) {
        return api.post('/students/contact', message);
    },
    patchCareerPreference(studentUuid, prefUuid, payload) {
        return api.patch(`/students/student/${studentUuid}/career_preference/${prefUuid}/imparted_careers`, payload);
    },
    patchCareerPreferenceRanks(studentUuid, payload) {
        return api.patch(`/students/student/${studentUuid}/career_preference/ranks`, payload);
    },
    getSendFavorites(studentUuid) {
        return api.get(`/students/pdf_email/${studentUuid}`);
    },
};
